export default {
  data : () => {
    return {
      // 不需要
      /*formInputTypes1:[
        'text', 'password', 'email', 'number', 'url',
        'tel', 'date', `time`, 'range', 'color'
      ],*/
    }
  },
  methods: {
    // 待廢除,getRole集中在global-method裡,這個不再維護也避免使用
    getRole: function () {
      // 根據url的pathname決定當前是什麼身份在使用
      /*if (window.location.pathname.indexOf("/admin") === 0) {
        return "admin"
      }
      else if (window.location.pathname.indexOf("/user") === 0) { 
        return 'user'
      }
      else {
        return "merchant"
      }*/
      // 適應adminplugin子資料夾結構的getRole判斷
      if (window.location.pathname.indexOf("/adminplugin") === 0 && window.location.hash === '#merchant' ) {
        return "merchant"
      }
      else if (window.location.pathname.indexOf("/adminplugin") === 0 && window.location.hash === '#user') { 
        return 'user'
      }
      else {
        return "admin"
      }
    },
    testGlobalFunc: function (myVar) {
      alert(JSON.stringify(myVar))
    },
    calScrollRatio(evt) {
      return evt.target.scrollTop/(evt.target.scrollHeight-evt.target.clientHeight)
    },
    CpObj: function (o) {
      if (typeof o !== 'object') {
        return o;
      }
      if (!o) {
        return o;
      }
      if ('[object Array]' === Object.prototype.toString.apply(o)) {
        let newOA = [];
        for (let i = 0; i < o.length; i ++) {
          newOA[i] = this.CpObj(o[i]);
        }
        return newOA;
      }
      let newO = {};
      for (let j in o) {
        if (o.hasOwnProperty(j)) {
          newO[j] = this.CpObj(o[j]);
        }
      }
      return newO;
    },
    // 檢查物件是否空了...用mapping轉換物件時為避免無益的重複交叉迴圈比對,從來源assign到結果時就把來源屬性幹掉,若有剩下來的屬性則需放置到others
    isObjEmpty: function (map) {
      for (let key in map) {
        return !map.hasOwnProperty(key)
      }
      return true
    },
    getDateByStr: function (baseDateString = '', added_days = 0, defaultSplitter = '/') {
      // added_days可以是負數
      const baseDate = baseDateString==''? new Date() : new Date(baseDateString)
      baseDate.setDate(baseDate.getDate() + parseInt(added_days))
      //return baseDate.toISOString().split("T")[0]
      return this.toISODateString(baseDate, defaultSplitter)
    },
    toISODateString : function (d, defaultSplitter = '/') {
      // Date object to ISO date string(overcome date calc issue)
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const date = d.getDate()
      return year + defaultSplitter + (month<10?'0':'') + month + defaultSplitter + (date<10?'0':'') + date
    },
    humanFileSize(bytes, si) {
      // from stackoverflow
      let thresh = si ? 1000 : 1024;
      if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
      }
      let units = si
        ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
        : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
      let u = -1;
      do {
        bytes /= thresh;
        ++u;
      } while(Math.abs(bytes) >= thresh && u < units.length - 1);
      return bytes.toFixed(1)+' '+units[u];
    },
    checkMobile() {
      //if(window.innerWidth <= 800 && window.innerHeight <= 600) {
      // 用這個判斷才不會跑掉,上面那個變大scroll出來後容易誤判
      if (document.documentElement.clientWidth <= 600 && document.documentElement.clientHeight <= 900 ) {
        return true;
      } else {
        return false;
      }
    },
    isLineWebkit() {
      return navigator.userAgent.indexOf('Line') > -1
    },
    getBlobFromBase64(bin_data_str) {
      let byteCharacters = atob(bin_data_str)
      let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
    
      // base64的檔案binary可以被saveAs使用的參數,saveAs時的檔案檔名要自己放對的副檔名
      // 用法是 saveAs(this.getBlobFromBase64(bin_data_str),"file_name.extension")
      return new Blob([byteArray], {type: "application/octet-stream"});
    },
    getPartFromDatetimeStr(datetime_str = "1970-01-01 00:00:00", part='hour') {
      // 不寫太複雜,傳入格式必須固定為yyyy-mm-dd hh:mi:ss,後面可省略
      if (datetime_str === null) {
        return false
      }
      let rtn = -1
      switch (part) {
        case 'hour':
          if (datetime_str.length >=13) {
            rtn = datetime_str.substr(11,2)
          }
          break
        case 'year':
            if (datetime_str.length >=4) {
              rtn = datetime_str.substr(0,4)
            }
            break
        case 'month':
            if (datetime_str.length >=7) {
              rtn = datetime_str.substr(5,2)
            }
            break
        case 'day':
            if (datetime_str.length >=10) {
              rtn = datetime_str.substr(8,2)
            }
            break
        case 'date':
            if (datetime_str.length >=10) {
              rtn = datetime_str.substr(0,10)
            }
            break
        case 'datehour':
            if (datetime_str.length >=13) {
              rtn = datetime_str.substr(0,13)+':00:00'
            }
            break
        case 'datehourminute':
            if (datetime_str.length >=16) {
              rtn = datetime_str.substr(0,16)+':00'
            }
            break
        case 'minute':
            if (datetime_str.length >=16) {
              rtn = datetime_str.substr(14,2)
            }
            break
        case 'second':
            if (datetime_str.length >=19) {
              rtn = datetime_str.substr(17,2)
            }
            break
        case 'hourminute':
          if (datetime_str.length >=13) {
            rtn = datetime_str.substr(11,5)
          }
          break
      }
      return rtn===-1?false:(['hour','year','month','day','minute','second'].includes(part)?parseInt(rtn,10):rtn)
    },
    getTimestampFromDatetimeStr(datetime_str) {
      // safari對2019-07-05 12:00:00這樣的日期時間字串做new Date或Date.parse會NaN或有時區錯誤
      // 為了讓chrome和safari都能同樣計算出duration長度,只好加了這個很蠢的對空白隔開長度寫死19的日期時間字串的處理
      // 處理結果等同於new Date後getTime（）回傳的值
      let result = NaN
      if (datetime_str.length === 19) {
        let dt_arr = datetime_str.split(' ')
        if (dt_arr.length === 2) {
          let date_stamp = new Date(dt_arr[0]).getTime()
          let time_arr = dt_arr[1].split(':')
          let time_stamp = (+time_arr[0]) * 60 * 60 + (+time_arr[1]) * 60 + (+time_arr[2])
          result = date_stamp + time_stamp*1000
        }
      }
      return result
    },
    //抄來改的,取得get url參數的值,無此參數回傳false
    getQueryVariable(variable) {
      //有hash就沒search,改動態判斷
      let query = window.location.search?window.location.search.substring(window.location.search.indexOf('?')+1):window.location.hash.substring(window.location.hash.indexOf('?')+1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split('=');
          if (decodeURIComponent(pair[0]) == variable) {
              return decodeURIComponent(pair[1]);
          }
      }
      return false
    },
    resetUrlQuery(append_url = '') {
      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + append_url;
        window.history.pushState({path:newurl},'',newurl);
      }
    },
    mapUrlKey(url_key) {
      let mapper = {
        "SUPPLIER_ID": "supplier_id",
        "NI": "ni",
      }
      if (mapper[url_key]) {
        return mapper[url_key]
      }
      else {
        return ''
      }
    },
    appendParamToUrl: function(url ,key, value){
      let now_url = new URL(url)
      now_url.searchParams.set(key,value)
      return now_url.href
    },
    removeParamToUrl: function(url ,key) {
        let now_url = new URL(url)
        now_url.searchParams.delete(key)
        return now_url.href
    }
  }
}
